import React, { Component } from 'react';
import {BounceLoader} from 'react-spinners';
import { Link, browserHistory } from 'react-router';
import Waypoint from 'react-waypoint';
import ClassNames from 'classnames';
import Navigator from 'components/NavigatorComponent';
import PostCardComponent from 'components/PostCardComponent'
import Moment from 'moment';
import API from 'sources/API';
import ProductStore from 'stores/ProductStore';
import ProductActions from 'actions/ProductActions';

require('./Route.scss');
require('styles/Comments.scss');
require('styles/SweetLoading.scss');
Moment.locale('zh-cn');

const $ = window.$;
let FixedHeight = 250;
class RouteComponent extends Component{
  constructor(props) {
    super(props);
    let productStore = ProductStore.getState();
    this.state = {
      product: productStore.product,
      consultant: null,
      is_collect: false,
      teams: [],
      comments: [],
      menuIndex: 1,
      showConsultant: false,
      showPostCard: false,
      menuFixed: false,
      needRefreshHeight: false,
      loading: true,
      historyTeams: [],
      scrollInverval: null
    };
    this.onProductChange = this.onProductChange.bind(this);
    this.clickMenu = this.clickMenu.bind(this);
    this.collectProduct = this.collectProduct.bind(this);
    this.unCollectProduct = this.unCollectProduct.bind(this);
    this.toggleConsultantCard = this.toggleConsultantCard.bind(this);
    this.togglePostCard = this.togglePostCard.bind(this)
    this.fixMenuComponent = this.fixMenuComponent.bind(this);
    this.relativeMenuComponent = this.relativeMenuComponent.bind(this);
    this.acquireHistoryTeam = this.acquireHistoryTeam.bind(this)
    this.joinTeam = this.joinTeam.bind(this);
  }
  componentWillMount(){
    let product_id = this.props.params.id;
    ProductActions.fetchProduct(product_id);
    ProductActions.fetchTeams(product_id);
    ProductActions.fetchComments(product_id);
    this.acquireHistoryTeam()
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }

    window.scrollTo(0, 0);
    ProductStore.listen(this.onProductChange);
    this.scrollInverval = setInterval(() => {
      $('.history-teams').find("ul:first").animate({marginTop: "-30px"},500,function() {
          $(this).css({
            marginTop: "0px"
          }).find("li:first").appendTo(this);
      });
    }, 2000)

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount(){
    clearInterval(this.scrollInverval)
    ProductStore.unlisten(this.onProductChange);
    ProductActions.clearProduct();
  }
  componentDidUpdate(){
    if(this.state.needRefreshHeight){
      let index = this.state.menuIndex;
      let productStore = ProductStore.getState();
      let height = $('.basic-info').height() + 30;
      if(index === 1){
        if(this.state.menuFixed&&productStore.offset<height){
          window.scrollTo(0,height);
        }else{
          window.scrollTo(0,productStore.offset);
        }
      }else if(index === 2){
        if(this.state.menuFixed&&productStore.planOffset<height){
          window.scrollTo(0,height);
        }else{
          window.scrollTo(0,productStore.planOffset);
        }
      }else if(index === 4){
        if(this.state.menuFixed&&productStore.commentOffset<height){
          window.scrollTo(0,height);
        }else{
          window.scrollTo(0,productStore.commentOffset);
        }
      }else if(index === 3){
        if(this.state.menuFixed&&productStore.tipsOffset<height){
          window.scrollTo(0,height);
        }else{
          window.scrollTo(0,productStore.tipsOffset);
        }
      }
      this.state.needRefreshHeight = false;
    }
  }
  onProductChange(state){
    this.setState({
      product: state.product,
      menuIndex: state.product.content == '<p>xiaodiqiu.cn</p>'?2:1,
      loading: (state.product._id&&state.product._id===this.props.params.id)?false:true,
      consultant: state.product?state.product.consultant:null,
      is_collect: state.product?state.product.is_collect:false,
      teams: state.teams,
      comments: state.comments
    })

    let product = state.product;
    if(product&&product.title){
      window.wx.onMenuShareTimeline({
        title: `${product.title}-小地球旅行`, // 分享标题
        link:  location.href, // 分享链接
        imgUrl: encodeURI(product.cover.small) // 分享图标
      });
      window.wx.onMenuShareAppMessage({
        title: `${product.title}-小地球旅行`, // 分享标题
        desc: `${product.title}。加入小地球旅行，发现有趣的地方`, // 分享描述
        link: location.href, // 分享链接
        imgUrl: encodeURI(product.cover.small), // 分享图标
        type: 'link' // 分享类型,music、video或link，不填默认为link
      });

      window.changeMetaForSEO(product.title)
    }
  }
  clickMenu(index){
    let orginIndex = this.state.menuIndex;
    if(index != orginIndex){
      if(orginIndex === 1){
        ProductActions.updateProductOffset($(document).scrollTop());
      }else if(orginIndex === 2){
        ProductActions.updateProductPlanOffset($(document).scrollTop());
      }else if(orginIndex === 3){
        ProductActions.updateProductTipsOffset($(document).scrollTop());
      }else if(orginIndex === 4){
        ProductActions.updateProductCommentOffset($(document).scrollTop());
      }
      this.setState({menuIndex:index,needRefreshHeight:true});
    }
  }
  collectProduct(){
    let product_id = this.props.params.id;
    let params = {
      method: 'POST',
      headers: API.urlHeader,
      body: `accessToken=${API.accessToken}&product_id=${product_id}`
    };
    let that = this;
    fetch(API.postCollectProduct.replace(':id', product_id), params)
      .then(res=>res.json())
      .then(json=>{
        if(json.status == 0){
          that.setState({is_collect: true})
        }
      });
  }
  unCollectProduct(){
    let product_id = this.props.params.id;
    let params = {
      method: 'POST',
      headers: API.urlHeader,
      body: `accessToken=${API.accessToken}&product_id=${product_id}` 
    };
    let that = this;
    fetch(API.postUncollectProduct.replace(':id', product_id), params)
      .then(res=>res.json())
      .then(json=>{
        if(json.status == 0){
          that.setState({is_collect: false})
        }
      });
  }
  toggleConsultantCard(){
    this.setState({
      showConsultant: !this.state.showConsultant
    })
  }
  togglePostCard(){
    this.setState({
      showPostCard: !this.state.showPostCard
    })
  }
  relativeMenuComponent(){
    if($(document).scrollTop()>FixedHeight){
      this.setState({menuFixed:false})
    }
  }
  fixMenuComponent(){
    if($(document).scrollTop()>FixedHeight){
      this.setState({menuFixed:true})
    }
  }
  joinTeam(team){
    let check = API.checkToken;
    if(check){
      browserHistory.push({pathname:`/checkout/${this.state.product._id}`,state:{product:this.state.product,team:team}})
    }
  }
  acquireHistoryTeam() {
    let product_id = this.props.params.id;
    let params = {
      method: 'GET',
      headers: API.jsonHeader
    };
    let searchParams = new URLSearchParams();
    searchParams.append('maxCount',5)
    searchParams.append('end',Moment().format('YYYY-MM-DD'))
    fetch(`${API.getHistoryTeamss.replace(':id', product_id)}&${searchParams}`, params)
      .then(res=>res.json())
      .then(json=>{
        if(json.status == 0){
          if(json.result.length){
            FixedHeight += 80
          }
          this.setState({historyTeams: json.result})
        }
      });
  }
  render(){
    let slides = [], actions;
    for (let index = 0; index < 1; index++) {
      slides.push()
    }
    let ct = '';
    if(this.state.menuIndex == 1){
      ct = this.state.product.content;
    }else if(this.state.menuIndex == 2){
      ct = this.state.product.plan;
    }else if(this.state.menuIndex == 3){
      ct = this.state.product.tips;
    }

    let isShowContent = this.state.product.content?this.state.product.content!='<p>xiaodiqiu.cn</p>':false
    let isShowComments = this.state.comments.length?true:false
    let columnCount = 4
    if (!isShowContent) columnCount -= 1
    if (!isShowComments) columnCount -= 1
    const columnWidth = 12 / columnCount 

    let collectButton = (<div className="collect action columns small-7" onClick={this.collectProduct}>
      <i className="fa fa-heart" aria-hidden="true"></i>&nbsp;收藏到心愿单
    </div>);
    if(this.state.is_collect){
      collectButton = (<div className="collect action columns small-7" onClick={this.unCollectProduct}>
      <i className="fa fa-heart collected" aria-hidden="true"></i>&nbsp;已添加心愿单
    </div>)
    }

    if(this.state.menuIndex == 2){
      actions = (<div className="actions">
        {collectButton}
        <Link to={{
          pathname:`/checkout/${this.state.product._id}`,
          state:{product:this.state.product}}} 
          className="order action columns small-5">
            ¥{this.state.product.deposit}&nbsp;发新团
        </Link>
      </div>);
    }

    let consultantReveal;
    if(this.state.consultant&&this.state.showConsultant){
      let consultant = this.state.consultant;
      consultantReveal = (<div className="segment consultant">
        <button onClick={this.toggleConsultantCard} className="close-button" type="button">
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="tip">顾问微信名片</div>
        <div className="qr"><img src={consultant.wechat_qr} /></div>
        <div className="info mt-10">
          <div className="avatar-warp ml-5"><img className="avatar" src={consultant.avatar} /></div>
          <div className="left float ml-5 pt-3">
            <div className="name">{consultant.name}</div>
            <div className="email">微信号：{consultant.wechat}</div>
          </div>
        </div>
      </div>);
    }

    let postCardReveal;
    if(this.state.showPostCard&&this.state.product._id){
      const texts = this.state.product.title.split('|')
      postCardReveal = <PostCardComponent
                         title = {texts[0]}
                         desc = {texts[1]}
                         cover = {this.state.product.cover.big}
                         togglePostCard = {this.togglePostCard}
                       />
    }

    let renderScore = (score) => {
      let scoreComponent = [];
      for (let index = 1; index < 6; index++) {
        if(score >= index){
          scoreComponent.push(<i key={`star-${index}`} className="fa fa-star ml-5" aria-hidden="true"></i>)
        }else{
          scoreComponent.push(<i key={`star-${index}`} className="fa fa-star-o ml-5" aria-hidden="true"></i>)
        }
      }
      return scoreComponent;
    }

    let componentClass = ClassNames({
      'card': true,
      'content-menu': true,
      'fixed': (this.state.menuFixed&&($(document).scrollTop()>FixedHeight))
    });

    let historyTeam;
    if(this.state.historyTeams.length){
      historyTeam = (
        <div className="card history-teams">
          <div className="cat">历史团期</div>
          <div className="content">
            <ul>
              {this.state.historyTeams.map((team) => {
                return (<li className="history-team" key={team._id}>
                  <div className="time">{team.start_date}</div>
                  {team.links.map(link => <div className="link" key={link._id}>{`${link.name[0]}**`}</div>)}
                </li>)
              })}
            </ul>
          </div>
        </div>
      )
    }
    return (
      <div className="route-component">
      <div className='sweet-loading'>
        <BounceLoader
          sizeUnit={"px"}
          size={50}
          color={'#333'}
          loading={this.state.loading}
        />
      </div>
        <div className="detail">
          <div className="basic-info">
            {consultantReveal}
            {postCardReveal}
            <div className="card">
              <div className="cover-warp">
                {this.state.product.cover?<img className="slide" src={this.state.product.cover.big}></img>:null}
              </div>
              <div className="part">
                <div className="column small-9">
                  <div className="title">{this.state.product.title}</div>
                  <div className="price">¥{this.state.product.price}</div>
                </div>
                <div className="column small-3 mb-0" onClick={this.toggleConsultantCard}>
                  <div className="avatar-warp">
                    <img 
                      className="avatar" 
                      src={this.state.consultant?this.state.consultant.avatar:'https://img.xiaodiqiu.cn/avatar.jpeg'}>
                    </img>
                  </div>
                  <div className="nickname">联系顾问</div>
                </div>
                <div className="clear"></div>
              </div>
            </div>
            <div className="card">
              <div className="cat">特色</div>
              <div>
                {this.state.product.features&&this.state.product.features.map((feature) => {
                  return <button className="feature" key={feature._id}>{feature.name}</button>;
                })}
                {this.state.product.feature&&this.state.product.feature.name?
                  <button className="feature">{this.state.product.feature.name}</button>:null}
              </div>
            </div>
            <div className="card">
              <div className="cat">最近团期</div>
              <div className="teams">
                <div className="teams-warp" style={{width:`${200 * this.state.teams.length + 400}px`}}>
                  {this.state.teams.map((team) => {
                    if(team.rest_number && team.rest_number < team.member_number && team.link_number != team.member_number){
                      return (
                        <a href="javascript:void(0)" key={team._id} onClick={this.joinTeam.bind(null,team)} className="team">
                          <div className="date date-coral fz-12 mt-10">出发日期:&nbsp;{team.start_date}&nbsp;({Moment(team.start_date).format('dddd')})</div>
                          <div className="date date-coral fz-12">返回日期:&nbsp;{team.end_date}&nbsp;({Moment(team.end_date).format('dddd')})</div>
                          <div className="number fz-12 mt-5">{team.member_number}人团 余位{team.rest_number}</div>
                          <div className="number fz-12">拼团价：<span className="price fz-16">¥{team.member_price}</span></div>
                          <div className="join send fz-12">拼团中</div>
                        </a>
                      )
                    }else{
                      if(team.link_number == team.member_number || team.rest_number > team.member_number){
                        return (
                          <a href="javascript:void(0)" key={team._id} className="team full">
                            <div className="date fz-12 mt-10">出发日期:&nbsp;{team.start_date}&nbsp;({Moment(team.start_date).format('dddd')})</div>
                            <div className="date fz-12">返回日期:&nbsp;{team.end_date}&nbsp;({Moment(team.end_date).format('dddd')})</div>
                            <div className="number fz-12 mt-5">{team.member_number}人团 余位0</div>
                            <div className="number fz-12">拼团价：<span className="price fz-16">¥{team.member_price}</span></div>
                            <div className="join fz-12">已成团</div>
                          </a>
                        )
                      }else{
                        return (
                          <a href="javascript:void(0)" key={team._id} onClick={this.joinTeam.bind(null,team)} className="team">
                            <div className={team.link_number>0?'date date-coral fz-12 mt-10':'date fz-12 mt-10'}>出发日期:&nbsp;{team.start_date}&nbsp;({Moment(team.start_date).format('dddd')})</div>
                            <div className={team.link_number>0?'date date-coral fz-12':'date fz-12'}>返回日期:&nbsp;{team.end_date}&nbsp;({Moment(team.end_date).format('dddd')})</div>
                            <div className="number fz-12 mt-5">{team.member_number}人团 余位{team.member_number - team.link_number}</div>
                            <div className="number fz-12">拼团价：<span className="price fz-16">¥{team.member_price}</span></div>
                            {team.link_number > 0?<div className="join send fz-12">拼团中</div>:<div className="join fz-12">加入此团</div>}
                          </a>
                        )
                      }
                    }
                  })}
                </div>
                {this.state.teams.length?'':<div className="blank">~ 两人任意时间即可出发，详情请咨询微信顾问 ~</div>}
              </div>
            </div>
            {historyTeam}
            <div className="card tips">
              {this.state.product.points&&this.state.product.points.map((point,index) => {
                return (<div className="tip" key={`point-${index}`}><i className="fa fa-bell" aria-hidden="true"></i>&nbsp;{point}</div>)
              })}
              <div className="tip" style={{borderBottom:'none'}}><i className="fa fa-bell" aria-hidden="true"></i>&nbsp;费用明细等详细信息请查看注意事项内的说明</div>
            </div>
          </div>
          <Waypoint
            onEnter={this.relativeMenuComponent}
            onLeave={this.fixMenuComponent}
          />
          <div className={componentClass}>
            {isShowContent?<div className={`columns small-${columnWidth} menu ${this.state.menuIndex==1?'active':''}`} onClick={this.clickMenu.bind(this,1)}>探索发现</div>:null}
            <div className={`columns small-${columnWidth} menu ${this.state.menuIndex==2?'active':''}`} onClick={this.clickMenu.bind(this,2)}>行程安排</div>
            <div className={`columns small-${columnWidth} menu ${this.state.menuIndex==3?'active':''}`} onClick={this.clickMenu.bind(this,3)}>注意事项</div>
            {isShowComments?<div className={`columns small-${columnWidth} menu ${this.state.menuIndex==4?'active':''}`} onClick={this.clickMenu.bind(this,4)}>用户评价</div>:null}
            <div className="clear"></div>
          </div>
          {this.state.menuIndex==4?(<div className="comments-component" style={(this.state.menuFixed&&($(document).scrollTop()>FixedHeight))?{'marginTop':'100px',height:'500px',background:'white'}:{height:'500px',background:'white'}}>{
            this.state.comments.length?this.state.comments.map((comment) => {
              return <div className="comment bg-white" key={comment._id}>
                <div className="comment-meta clearfix">
                  <img className="comment-avatar float-left contain" width="30" height="30" src={comment.author.avatar + '!li150'} />
                  <h4 className="float-left">
                    <span className="text-black">{comment.author.name}</span>
                  </h4>
                  <span className="fz-12 text-gray float-right">{comment.comment_time?comment.comment_time:`${new Date(comment.create_date).toLocaleDateString()} ${new Date(comment.create_date).toLocaleTimeString()}`}</span>
                </div>
                <div className="comment-content">{comment.content}</div>
                <div className="score"><span className="fz-12 text-gray">推荐指数:</span> {renderScore(comment.score)}</div>
              </div>
            }):(<div className="empty">暂无评价</div>)
          }</div>)
            :
            <div className={this.state.menuIndex==1?"route-feature route-content":"route-feature"} style={(this.state.menuFixed&&($(document).scrollTop()>FixedHeight))?{'marginTop':'100px'}:{}} dangerouslySetInnerHTML={{__html:ct}}></div>
          }
        </div>
        <Navigator action='share' number={5} callback={this.togglePostCard} />
        <Navigator action='home' number={4} />
        <Navigator action='consult' number={3} callback={this.toggleConsultantCard}/>
        <Navigator action='top' number={2} />
        <Navigator action='left' />
        {actions}
      </div>
    );
  }
}

export default RouteComponent;




// WEBPACK FOOTER //
// ./src/develop/RouteComponent.js